import { acceptHMRUpdate, defineStore } from 'pinia';
import { ref } from 'vue';
import axios from 'axios';

export const useCompoundStore = defineStore('compound', () => {
    const all = ref({ data: [] });

    const reset = () => {
        all.value = { data: [] };
    };

    const compoundOptions = ref([]);

    const labCompounds = ref([]);

    const search = (params) => {
        return axios.get('/api/v1/compounds', { params });
    };

    const store = (params) => {
        return axios.post('/api/v1/compounds', params);
    };

    const update = (params) => {
        return axios.patch('/api/v1/compounds/' + params.hash, params);
    };

    const copy = (params) => {
        return axios.post('/api/v1/compounds/' + params.hash + '/copy', params);
    };

    const destroy = (params) => {
        return axios.delete('/api/v1/compounds/' + params.hash);
    };

    const searchLabCompounds = (params) => {
        return axios.get(`/api/v1/labs/${params.labHash}/compounds`, { params });
    };

    const favoriteLabCompound = (params) => {
        const { labHash, compoundHash, ...query } = params;
        return axios.post(
            `/api/v1/labs/${labHash}/compounds/${compoundHash}/favorite`,
            {},
            { params: query }
        );
    };

    const unfavoriteLabCompound = (params) => {
        const { labHash, compoundHash, ...query } = params;
        return axios.delete(
            `/api/v1/labs/${labHash}/compounds/${compoundHash}/favorite`,
            { params: query }
        );
    };

    return {
        all,
        reset,
        search,
        store,
        copy,
        update,
        destroy,
        compoundOptions,
        labCompounds,
        searchLabCompounds,
        favoriteLabCompound,
        unfavoriteLabCompound
    };
});

// HMR
if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useCompoundStore, import.meta.hot));
}
